// Ajax cart JS for Drawer and Cart Page
const drawerSelectors = {
  cartIcons: document.querySelectorAll(".header__icon--cart"),
  cartIconDesktop: document.querySelector("#cart-icon-desktop"),
  cartIconMobile: document.querySelector("#cart-icon-mobile"),
  cartDrawerCount: document.querySelector("[data-drawer-cart-count]"),
};

window.theme = window.theme || {};
window.theme.vip = window.theme.vip || {};
window.theme.vip.auto_discount_percent = window.theme.vip.auto_discount_percent || 0;

if (typeof enableprogressbar !== 'undefined' && enableprogressbar === true) {
  const special_prod_ids = [];
  const bundle_prod_ids = [];

  specialProducts.forEach(prod => {
    special_prod_ids.push(prod.id);
  });

  bundleQualifyingProducts.forEach(prod => {
    bundle_prod_ids.push(prod.id);
  });

  // Fetch the discountCodes from the Liquid variable
  //console.log("++++++++++++++++++++++++Discount codes++++++++++++++++++++++++++++++++++++++");

  // Split the string into an array
  var discountArray = discountCodes.split(',');
  var discountAmountsArray = window.strDiscountAmounts.split(',');

  // Create the object with indexes
  const specialDiscountCodes = {};
  discountArray.forEach((code, index) => {
    specialDiscountCodes[index + 1] = code.trim(); // Add to the object with 1-based index
  });

  const discountAmounts = {};
  discountAmountsArray.forEach((amount, index) => {
    discountAmounts[index + 1] = parseInt(amount);
  });


  //Bundle discount

  // Split the string into an array
  var bundlediscountArray = bundlediscountCodes.split(',');

  // Create the object with indexes
  const bundleDiscountCodes = {};
  bundlediscountArray.forEach((code, index) => {
    bundleDiscountCodes[index + 1] = code.trim(); // Add to the object with 1-based index
  });

  // Function to change cart text (unchanged)
  function changeCartText() {
    var firstSpan = document.querySelector('.docapp-cart-subtotal span');
    if (firstSpan) {
      console.log("here is the price");
      firstSpan.textContent = "Price"; // Set the new text
    }
  }

  // Function to get cart data (unchanged)
  function getCartData_progress() {
    //console.log("Fetching cart data...");
    return fetch('/cart.js')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok.');
        }
        //console.log("Cart data fetched successfully.");
        return response.json();
      })
      .then(data => {
        //console.log("Cart data:", data); // Log full cart data
        if (data.item_count > 0) {
          document.querySelector('.discount-container').style.display = 'block';
        } else {
          document.querySelector('.discount-container').style.display = 'none';
        }
        return data;
      })
      .catch(error => {
        console.log(error);
      });
  }

  // Function to check how many special products are in the cart (capped at 3 devices)
  function checkSpecialProducts(cartData) {
    let specialProductsCount = 0; // Full-sized products (e.g. Omnilux Clear, Men, Contour Face, etc.)
    let bundleProductCount = 0;      // Bundle products (e.g. Clear Skin Bundle, His Anti-Aging Bundle, Hers Anti-Aging Bundle, etc.)
    let eaProductCount = 0;          // EA collection's products (see theme settings / Theme Features)

    let bundleAgeRenewalCount = 0;      // Age-Renewal Bundle product count

    cartData.items.forEach(item => {
      if (special_prod_ids.includes(item.product_id)) {
        specialProductsCount += item.quantity;
      }

      if (bundle_prod_ids.includes(item.product_id)) {
        bundleProductCount += item.quantity;
      }

      if (bundleAgeRenewalId == item.product_id) {
        bundleAgeRenewalCount += item.quantity;
      }

      if (eaProductIds.includes(item.product_id)) {
        eaProductCount += item.quantity;
      }
    });
    
    // Cap the qualifying product count to a maximum of 3 devices
    if (specialProductsCount > 3) {
      specialProductsCount = 3;
    }

    return {
      specialProductsCount,
      bundleProductCount,
      eaProductCount,
      bundleAgeRenewalCount
    };
  }

  // Function to check and remove existing discount codes
  function checkAndRemovePreviousDiscount() {
    const appliedDiscountElement = document.querySelector('.docapp-coupon-input--bean-container--bean-remove');

    if (appliedDiscountElement) {
      const appliedDiscountCode = appliedDiscountElement.getAttribute('data-code');

      const allDiscountCodes = [
        ...Object.values(specialDiscountCodes),
        ...Object.values(bundleDiscountCodes),
        eaDiscountCode
      ];

      if (allDiscountCodes.includes(appliedDiscountCode)) {
        //console.log(`Removing applied discount code: ${appliedDiscountCode}`);
        appliedDiscountElement.click(); // Trigger the click event to remove the discount
      } else {
        //console.log("No matching discount code to remove.");
      }
    } else {
      //console.log("No discount code applied.");
    }
  }


  // Function to update the progress bar, discount codes, and apply coupon to the input field
  function updateDiscounts(specialProductsCount, bundleProductCount, eaProductCount, bundleAgeRenewalCount) {
    const progressBar = document.getElementById('freeDiscountProduct');
    const firstCheckpoint = document.querySelector('.first_check_point');
    const secondCheckpoint = document.querySelector('.sec_check_point');
    const thirdCheckpoint = document.querySelector('.third_check_point');
    const discountMessage = document.querySelector('.discount-message');
    const couponCode = document.querySelector('.docapp-coupon-input--bean-container');
    const discountLabels = document.querySelectorAll('.discount-label span');
    const couponInput = document.querySelector('.docapp-coupon-input--input'); // Text input field for coupon
    const couponButton = document.querySelector('.docapp-coupon-input--button-text'); // Button for applying the coupon

    const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor" style="fill: red; width: 18px; height: 18px; margin-right: 8px;"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg>`;

    if ( !Utility.getCookie('is_ea') ) {
      // Clear all free shipping bar and discount code
      progressBar.value = 0;
      checkAndRemovePreviousDiscount();
      $(".custom_main_cart_bar").hide();
      $(".shippingbar").hide();
      return false;
    }

    if (bundleProductCount > 0) {
      $(".custom_main_cart_bar").hide();
      $(".shippingbar").show();
    } else {
      $(".custom_main_cart_bar").show();
      $(".shippingbar").hide();
    }
    // Reset progress bar and checkpoints
    progressBar.value = 0;
    firstCheckpoint.classList.add('inactive');
    secondCheckpoint.classList.add('inactive');
    thirdCheckpoint.classList.add('inactive');
    discountLabels.forEach(label => label.classList.add('inactive-label'));

    checkAndRemovePreviousDiscount();

    if ( !couponInput ) {
      return;
    }

    if (eaProductCount > 0 && eaDiscountCode != '') {
      couponInput.value = eaDiscountCode;
    } else {
      if (bundleProductCount > 0) {
        if (Object.keys(bundleDiscountCodes).length == 1) {
          // There is only 1 bundle discount code
          if (specialProductsCount > 0) {
            $(".custom_main_cart_bar").hide();
            $(".shippingbar").show();
            couponInput.value = bundleDiscountCodes[1]; 
          }
        } else {
          // More than 1 bundle discount code
          if (specialProductsCount > 0 && bundleAgeRenewalCount > 0) {
            // Added exception here: BUNDLE2VDAY_AGERENEWAL
            couponInput.value = 'BUNDLE2VDAY_AGERENEWAL';
          } else {
            if (specialProductsCount === 1) {
              couponInput.value = bundleDiscountCodes[1];
            } else if (specialProductsCount >= 2) {
              couponInput.value = bundleDiscountCodes[2];
            } else {
              couponInput.value = "";
              checkAndRemovePreviousDiscount();
            }
          }
        }
      
      } else {
        // No bundle
        if(Object.keys(specialDiscountCodes).length == 1){
          if (specialProductsCount > 0) {
            $(".custom_main_cart_bar").hide();
            $(".shippingbar").show();
            couponInput.value = specialDiscountCodes[1];
          }else{
            discountMessage.textContent = `Buy 1 LED Device for $${discountAmounts[1]} OFF!`;
            couponInput.value = "";
            checkAndRemovePreviousDiscount();
            $(".custom_main_cart_bar").hide();
            $(".shippingbar").show();
          }
        } else {
          
          if (specialProductsCount === 1) {
            progressBar.value = 33;
            firstCheckpoint.classList.remove('inactive');
            discountMessage.textContent = `Discount activated! Save $${discountAmounts[2]} USD with one more LED device.`;
            if (couponCode) {
              couponCode.innerHTML = `${svgIcon}$${discountAmounts[1]} Off Applied.`;
            }
            discountLabels[0].classList.remove('inactive-label');
            couponInput.value = specialDiscountCodes[1];
          } else if (specialProductsCount === 2) {
            progressBar.value = 66;
            firstCheckpoint.classList.remove('inactive');
            secondCheckpoint.classList.remove('inactive');
            discountMessage.textContent = `Discount activated! Save $${discountAmounts[3]} USD with one more LED device.`;
            if (couponCode) {
              couponCode.innerHTML = `${svgIcon}$${discountAmounts[2]} Off Applied.`;
            }
            discountLabels[1].classList.remove('inactive-label');
            couponInput.value = specialDiscountCodes[2];
          } else if (specialProductsCount === 3) {
            progressBar.value = 100;
            firstCheckpoint.classList.remove('inactive');
            secondCheckpoint.classList.remove('inactive');
            thirdCheckpoint.classList.remove('inactive'); // Activate third checkpoint
            discountMessage.textContent = `Congrats! You saved $${discountAmounts[3]} USD.`;
            if (couponCode) {
              couponCode.innerHTML = `${svgIcon}$${discountAmounts[3]} Off Applied.`;
            }
            discountLabels[2].classList.remove('inactive-label');
            couponInput.value = specialDiscountCodes[3];
          } else {
            discountMessage.textContent = `Buy 1 LED Device for $${discountAmounts[1]} OFF!`;
            couponInput.value = "";
            checkAndRemovePreviousDiscount();
          }
        }
      }
    }
  
    // Automatically apply the discount if a coupon is present
    if(couponInput){
      if (couponInput.value) {
        setTimeout(() => {
          couponButton.click();
        }, 500);
      }
    }
  }


}



class AjaxCart extends HTMLElement {
  constructor() {
    super();

    this.openedBy = drawerSelectors.cartIcons;
    this.isOpen = this.classList.contains("open--drawer");
    this.bindEvents();
    this.cartNoteInput();
    this.querySelectorAll(".close-ajax--cart").forEach((button) =>
      button.addEventListener("click", this.closeCartDrawer.bind(this))
    );

    document
      .querySelectorAll("[data-gwp-close]")
      .forEach((button) =>
        button.addEventListener("click", this.closePopup.bind(this))
      );
    document
      .querySelectorAll("[add-gwp-product]")
      .forEach((button) =>
        button.addEventListener("click", this.addMultiGWPProduct.bind(this))
      );

    if (window.globalVariables.template != "cart") {
      this.addAccessibilityAttributes(this.openedBy);
      this.addRemoveProductsHandler();
    } else {
      this.style.visibility = "visible";
    }

    if ( !window.globalVariables.calledGetCartData ) {
      this.getCartData();
    }

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.watchDocapp();      
  }

  
  watchDocapp() {

    waitForElm(".docapp-cart-with-coupon-summary").then(() => {
      // Target the subtotal container
      const couponSummary = document.querySelector('.docapp-cart-with-coupon-summary'); 
      // ^ adjust selector based on your theme (sometimes `.cart__subtotal` or `.drawer-subtotal`)

      if (couponSummary) {
        this.recalcTax();

        let recalcTimer = false;
        
        this.docappObserver = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            if (mutation.type === "childList") {
              // console.log('Updated couponSummary', mutation);

              if (recalcTimer) {
                // console.log('-- cancelled previous recalcTimer ---');
                clearTimeout(recalcTimer);
              }

              recalcTimer = setTimeout(() => {              
                if (!window.updatingCouponSummary) {
                  this.docappObserver.disconnect();

                  this.recalcTax();

                  this.docappObserver.observe(couponSummary, {
                    childList: true,        // detect added/removed child nodes
                    characterData: true,    // detect text changes
                    subtree: true           // observe all descendant nodes
                  });
                }
              }, 200);
            }
          }
        });

        this.docappObserver.observe(couponSummary, {
          childList: true,        // detect added/removed child nodes
          characterData: true,    // detect text changes
          subtree: true           // observe all descendant nodes
        });
      }
    });
  }

  manageQtyInput(event) {
    let input = event.currentTarget;
    if (input.value < 0) input.value = Math.abs(input.value);
    if (input.value.length > 2) input.value = input.value.slice(0, 2);
  }

  /**
   * Observe attribute of component
   *
   * @returns {array} Attributes to Observe
   */
  static get observedAttributes() {
    return ["updating"];
  }

  /**
   * To Perform operation when attribute is changed
   * Calls attributeChangedCallback() with params when attribute value is updated
   *
   * @param {string} name attribute name
   * @param {string} oldValue attribute Old value
   * @param {string} newValue attribute latest value
   */
  attributeChangedCallback(name, _oldValue, newValue) {
    // called when one of attributes listed above is modified
    if (name == "updating" && newValue == "false") {
      this.updateEvents();
    }
  }

  /**
   * Add accessibility attributes to Open Drawer buttons
   *
   * @param {Node Array} openDrawerButtons Cart Icons
   */
  addAccessibilityAttributes(openDrawerButtons) {
    let _this = this;
    openDrawerButtons.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", _this.id);
    });
  }

  /**
   * Escape Click event to close drawer when focused within Cart Drawer
   *
   * @param {event} Event instance
   */
  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    this.querySelector(".close-ajax--cart").dispatchEvent(new Event("click"));
  }

  /**
   * bind dclick and keyup event to Cart Icons
   * bind keyUp event to Cart drawer component
   * bind Other inside element events
   *
   */
  bindEvents() {
    if (window.globalVariables.template != "cart") {
      this.openedBy.forEach((cartBtn) =>
        cartBtn.addEventListener("click", this.openCartDrawer.bind(this))
      );
      this.addEventListener("keyup", this.onKeyUp.bind(this));
    }
    // this.updateEvents();
  }

  /**
   * bind Other inside element events to DOM
   *
   */
  updateEvents() {
    // 1 of 3
    this.querySelectorAll("[data-add-gift]").forEach((button) => {
      button.addEventListener("click", this.addFreeGift.bind(this));
    });

    this.querySelectorAll("[data-remove-gift]").forEach((button) => {
      button.addEventListener("click", this.removeFreeGift.bind(this));
    });

    this.querySelectorAll("[data-itemRemove]").forEach((button) =>
      button.addEventListener("click", this.removeItem.bind(this))
    );
    this.querySelectorAll("[data-qty-btn]").forEach((button) =>
      button.addEventListener("click", this.manageQtyBtn.bind(this))
    );
    this.querySelectorAll("[data-qty-input]").forEach((button) =>
      button.addEventListener("change", this.onQtyChange.bind(this))
    );
    this.querySelectorAll("[data-gwp-multi-tier]").forEach((button) =>
      button.addEventListener("click", this.openPopup.bind(this))
    );
  }

  addFreeGift(event) {
    document.querySelector('.cart-gwp').classList.add('gwp-pending');

    const currentSelectedGwpItem = document.querySelector('.cart-drawer .cart-gwp-item.is-selected');
    if (currentSelectedGwpItem) {
      currentSelectedGwpItem.classList.remove('is-selected');
      currentSelectedGwpItem.querySelector('[data-add-gift]').removeAttribute('disabled');
    }

    const btn = event.currentTarget;
    btn.setAttribute('disabled', "");
    const gwpItem = btn.closest('.cart-gwp-item');
    gwpItem.classList.add('is-selected');
    
    let variantIdToAdd = false;
    if (typeof btn.dataset.variantId !== 'undefined') {
      variantIdToAdd = event.currentTarget.dataset.variantId;
    } else {
      console.error('Invalid variant ID for free gift.');
      return;
    }

    // Remove existing free gift product
    const giftVariantIds = window.theme.giftWithPurchase.giftProducts.map(p => p.variantId);
    let variantIdToRemove = false;
    window.globalVariables.cart.items.forEach(item => {
      if (item.properties.free_gift && giftVariantIds.indexOf(item.id.toString()) != -1) {
        // Remove this gwp
        variantIdToRemove = item.id.toString();
      }
    });

    if (variantIdToRemove) {
      // Remove existing gift and add new.
      this.removeFreeProduct(variantIdToRemove, () => {
        this.addFreeProduct(variantIdToAdd, () => {
          document.querySelector('.cart-gwp').classList.remove('gwp-pending');
        });
      });
    } else {
      // Add new gift
      this.addFreeProduct(variantIdToAdd, () => {
        document.querySelector('.cart-gwp').classList.remove('gwp-pending');
      });
    }
  }

  removeFreeGift(event) {
    document.querySelector('.cart-gwp').classList.add('gwp-pending');

    // Remove existing free gift product
    const giftVariantIds = window.theme.giftWithPurchase.giftProducts.map(p => p.variantId);
    let variantIdToRemove = false;
    window.globalVariables.cart.items.forEach(item => {
      if (item.properties.free_gift && giftVariantIds.indexOf(item.id.toString()) != -1) {
        // Remove this gwp
        variantIdToRemove = item.id.toString();
      }
    });

    if (variantIdToRemove) {
      // Remove existing gift and add new.
      this.removeFreeProduct(variantIdToRemove);
    }
  }

  addRemoveProductsHandler() {
    document.addEventListener("upsell-product-added", (event) => {
      let promises = [];
      
      let pdpUpsellVariantId = event.detail.pdpUpsellVariantId;
      let pdpUpsellContainer = document.querySelector('.section-upgrade-bundle .cart-upsell');
      // Hide "Upgrade to bundle" section
      if (pdpUpsellContainer && pdpUpsellVariantId == pdpUpsellContainer.dataset.upsellVariantId) {
        document.querySelector('.section-upgrade-bundle').classList.add('hidden');
      }
      
      if ( !event.detail.productsToRemove ) {
        return;
      }

      event.detail.productsToRemove.forEach((variantId) => {
        if (window.globalVariables.cart.items.filter(e => e.id == variantId).length > 0) {
          promises.push(fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 0,
            }),
          }));
        }
      });

      Promise.all(promises).then(values => {
        if (values.length > 0 && values[0].ok) {
          this.getCartData("open_drawer");
        }
      });
    });    
  }

  renderUpsells() {
    // Do not include "shopify-section" in the selector, it will break the render
    // Use "?sections={section-id}" to render several sections

    // Fetch a Shopify section. shopify-section only if static section rendered with section tag
    fetch(window.Shopify.routes.root + "?section_id=cart-drawer", { cache: 'no-store' })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const source = html.querySelector(
          ".swiper-container.upsell-slider .swiper-wrapper"
        );
        const destination = document.querySelector(
          ".swiper-container.upsell-slider .swiper-wrapper"
        );

        const sourceTitle = html.querySelector(".cart-upsell-title");
        const destinationTitle = document.querySelector(".cart-upsell-title");

        destinationTitle.innerHTML = sourceTitle.innerHTML;
        destination.innerHTML = source.innerHTML;

        if (source.children.length == 0) {
          document.querySelector(".cart-upsell-title").style.display = "none";
        } else {
          document.querySelector(".cart-upsell-title").style.display = "block";
        }
      })
      .catch((error) => console.error(error));
  }

  recalcTax() {
    if (window.updatingCouponSummary) {
      return;
    }

    window.updatingCouponSummary = true;
  
    let formattedTotal = calculatePriceWithTaxes(
      window.globalVariables.cart.original_total_price,
      window.customerCountry
    );
    const finalText = window.theme.tax.show_tax ? `${formattedTotal} Incl. Tax` : formattedTotal;
  
    $('.docapp-cart-item.docapp-cart-subtotal .money').text(finalText);

    setTimeout(() => {
      window.updatingCouponSummary = false;
    }, 500);
  }  

  /**
   * Open Cart drawer and add focus to drawer container
   *
   * @param {event} Event instance
   */
  openCartDrawer(event) {
    /*
    let redirect_to_checkout = false;
    
    // If there is any line item where property including 'sale_auto_discount' exists.
    // -- e.g. sale_auto_discount_25: true, sale_auto_discount_15: true, sale_auto_discount_12: true, sale_auto_discount: true
    if (window.globalVariables.cart) {
      if (window.globalVariables.cart.items.some(item => Object.keys(item.properties).some(key => key.includes('sale_auto_discount')))) {
        redirect_to_checkout = true;
      }
    }
    
    if (redirect_to_checkout) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (window.theme.vip && window.theme.vip.auto_discount_code) {
        window.location.href = `/checkout/?discount=${window.theme.vip.auto_discount_code}`;
      } else {
        window.location.href = '/checkout';
      }
      return false;
    }
    */
    
    if (typeof(qualifyingProducts) != "undefined") {
      changeCartText();
      
      // Call this function to check and update discount codes
      getCartData_progress().then(cartData => {
          if (cartData && cartData.items) {
              const { specialProductsCount, bundleProductCount, eaProductCount, bundleAgeRenewalCount } = checkSpecialProducts(cartData);
              checkAndRemovePreviousDiscount();
              updateDiscounts(specialProductsCount, bundleProductCount, eaProductCount, bundleAgeRenewalCount);
          } else {
              console.error("Cart data is missing or empty.");
          }
      });
    }
    
    var isProgressBarEnabled = $('.shipping_bar').data('value');
    if (isProgressBarEnabled === true) {
      $(".delivery-shipping").parent().parent().hide();
    }
        
    if (!window.globalVariables.cart_drawer) {
      window.location.href = window.routes.cart_fetch_url || "/cart";
      return;
    }

    if (
      document
        .querySelector("#mobile-menu-drawer")
        .classList.contains("opened-drawer")
    ) {
      document
        .querySelector(".close-mobile--navbar")
        .dispatchEvent(new Event("click"));
    }

    this.classList.add("opened-drawer");
    siteOverlay.prototype.showOverlay();
    Utility.forceFocus(this.querySelector(".cart-title"));
    let closeBtn = this.querySelector(".close-ajax--cart");
    Utility.trapFocus(this, closeBtn);

    this.renderUpsells();

    if (event) {
      event.preventDefault();
      let openBy = event.currentTarget;
      openBy.setAttribute("aria-expanded", true);
    }

    // dispatch custom event cart-drawer:open
    document.dispatchEvent(new Event("cart-drawer:open"));
  }

  /**
   * Close Cart drawer and Remove focus from drawer container
   *
   * @param {event} Event instance
   */
  closeCartDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      event.preventDefault();
      this.classList.remove("opened-drawer");
      siteOverlay.prototype.hideOverlay();
      let openByEle = event.currentTarget;
      openByEle.setAttribute("aria-expanded", false);
      Utility.removeTrapFocus(elementToFocus);

      let actionBtn = drawerSelectors.cartIconDesktop;
      if (window.innerWidth < 1024) {
        actionBtn = drawerSelectors.cartIconMobile;
      }
      Utility.forceFocus(actionBtn);
    }
  }

  openPopup(event) {
    var getDivID = event.target.getAttribute("data-gwp-multi-tier");
    document
      .getElementById(getDivID)
      .querySelector(".modal")
      .classList.add("open");
    if (!event.currentTarget.hasAttribute("data-drawer-popup")) {
      siteOverlay.prototype.showOverlay();
    }
    document.querySelector("body").classList.add("gwp-tier-open");
  }

  closePopup(event) {
    event.target.closest(".modal").classList.remove("open");
    
    if (!event.currentTarget.hasAttribute("data-drawer-popup")) {
      siteOverlay.prototype.hideOverlay();
    }
    document.querySelector("body").classList.remove("gwp-tier-open");
  }

  calculatePriceWithTaxes(price, country) {
    const taxData = window.taxData;

    if (!taxData[country]) return price;
    return price * (1 + taxData[country]);
  }

  /**
   * Update cart HTML and Trigger Open Drawer event
   *
   * @param {string} cartHTML String formatted response from fetch cart.js call
   * @param {string} action Open Drawer as value if need to Open Cart drawer
   */
  _updateCart(response, action) {
    if (document.querySelector('.custom_main_cart_bar')) {
      changeCartText();
      // Call this function to check and update discount codes
      getCartData_progress().then(cartData => {
          if (cartData && cartData.items.length>0) {
            const { specialProductsCount, bundleProductCount, eaProductCount, bundleAgeRenewalCount } = checkSpecialProducts(cartData);
            checkAndRemovePreviousDiscount();
            updateDiscounts(specialProductsCount, bundleProductCount, eaProductCount, bundleAgeRenewalCount);
          } else {
            console.error("Cart data is missing or empty.");
          }
      });
    }
    // Convert the HTML string into a document object
    let cartHTML = "";
    if (window.globalVariables.template != "cart") {
      cartHTML = response["template-cart-drawer"];
    } else {
      cartHTML = response["template-cart"];
    }

    if (cartHTML == null) return;
    let parser = new DOMParser();
    cartHTML = parser.parseFromString(cartHTML, "text/html");

    let cartJSONEle = cartHTML.querySelector("[data-cartScriptJSON]");
    if (cartJSONEle != undefined && cartJSONEle != null) {
      window.globalVariables.cart = JSON.parse(cartJSONEle.textContent);
      
      if ( !window.removedAutoDiscount15Proudcts ) {
        // Remove property `sale_auto_discount_12`, `sale_auto_discount_15`, `sale_auto_discount_25` if exists
        window.removedAutoDiscount15Proudcts = true;

        let countRemoved = 0;
        window.globalVariables.cart.items.forEach(item => {
          if (item.properties && Object.keys(item.properties).some(key => key.includes('sale_auto_discount'))) {
            countRemoved++;

            let lineItemUpdate = {
              id: item.key,
              quantity: 0
            };

            // console.log('-- Removing properties --', lineItemUpdate);

            fetch("/cart/change.js", {
              body: JSON.stringify(lineItemUpdate),
              credentials: "same-origin",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "xmlhttprequest",
              },
              method: "POST",
            })
              .then(function (response) {
                return response.json();
              })
              .then(function (json) {
              })
              .catch(function (err) {
                console.error(err);
              });
          }
        });

        if (countRemoved) {
          setTimeout(() => {
            document.querySelector("ajax-cart").getCartData();
          }, 2000);
        }
      }

      if ( window.globalVariables.template == "cart" && window.globalVariables.cart && window.globalVariables.cart.items.some(item => Object.keys(item.properties).some(key => key.includes('sale_auto_discount')))) {
        window.location.href = '/checkout';
        return;
      }
    }

    let cartElement = cartHTML.querySelector("ajax-cart form");
    this.querySelector("form").innerHTML = cartElement.innerHTML;

    if (window.customerCountry !== "US" && window.customerCountry !== "CA") {
      this.querySelector("[data-carttotal]").innerHTML = Shopify.formatMoney(
      this.calculatePriceWithTaxes(
        window.globalVariables.cart.total_price,
        window.customerCountry
      ),
      window.globalVariables.money_format
    )+" Inc. Tax";
    }else{
      this.querySelector("[data-carttotal]").innerHTML = Shopify.formatMoney(
      this.calculatePriceWithTaxes(
        window.globalVariables.cart.total_price,
        window.customerCountry
      ),
      window.globalVariables.money_format
    );
    }

    let elements = this.querySelectorAll(
      "[data-checkoutBtns], [data-cartnote], [data-cartupsell]"
    );
    if (window.globalVariables.cart.item_count <= 0) {
      elements.forEach((div) => {
        div.classList.add("d-none");
      });
      if (document.querySelector("[data-upsell-product]")) {
        document.querySelector("[data-upsell-product]").classList.add("d-none");
      }
      drawerSelectors.cartDrawerCount.innerHTML = "0";
    } else {
      elements.forEach((div) => {
        div.classList.remove("d-none");
      });
      if (document.querySelector("[data-upsell-product]")) {
        document
          .querySelector("[data-upsell-product]")
          .classList.remove("d-none");
      }
    }
    this.setAttribute("updating", false);

    let cartCount = cartHTML.querySelector(
      "[data-drawer-cart-count]"
    ).innerHTML;
    if (drawerSelectors.cartIconDesktop.querySelector(".cart-count"))
      drawerSelectors.cartIconDesktop.querySelector(".cart-count").innerHTML =
        cartCount;
    if (drawerSelectors.cartIconMobile.querySelector(".cart-count"))
      drawerSelectors.cartIconMobile.querySelector(".cart-count").innerHTML =
        cartCount;
    if (window.globalVariables.cart.item_count > 0) {
      if (drawerSelectors.cartDrawerCount.querySelector(".cart-count"))
        drawerSelectors.cartDrawerCount.querySelector(".cart-count").innerHTML =
          cartCount;
    }

    document.querySelector("[data-drawer-cart-count]").innerHTML = cartCount;

    this.qtyInputs = this.querySelectorAll("input[data-qty-input]");
    this.qtyInputs.forEach((qtyInput) => {
      qtyInput.addEventListener("keyup", this.manageQtyInput.bind(this));
    });

    if (
      window.globalVariables.template != "cart"
    ) {
      if ( window.globalVariables.cart_drawer && action == "open_drawer" ) {
        this.openCartDrawer();
      } else {
        this.renderUpsells();
      }
    }
    
    // Extend - Dispatch event
    window.setTimeout(function () {
      window.dispatchEvent(new Event("refreshAjaxCart"));
      window.dispatchEvent(new Event("refreshAjaxSideCart"));
    }, 500);
    // Extend - End code
  }

  addGWPProduct(id, gwp_type) {
    if (gwp_type == "gwpc") {
      var body = {
        id: parseInt(id),
        quantity: 1,
        properties: {
          product_type: "gwpc",
          free_product: "true",
        },
      };
    } else if (gwp_type == "gwpp") {
      var body = {
        id: parseInt(id),
        quantity: 1,
        properties: {
          product_type: "gwpp",
          free_product: "true",
        },
      };
    } else if (gwp_type == "tier1") {
      var body = {
        id: parseInt(id),
        quantity: 1,
        properties: {
          product_type: "tier1",
          free_product: "true",
        },
      };
    }

    const result = fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    }).then((response) => {
      document.querySelector("ajax-cart").getCartData();
    });
  }

  addMultiGWPProduct(event) {
    event.preventDefault();
    event.stopPropagation();

    let currentTarget = event.currentTarget;
    let upsellProductVariantId =
      currentTarget.getAttribute("add-gwp-product") || null;
    var closeBtn = currentTarget
      .closest(".modal")
      .querySelector(".close-popup");
    var gwpType = currentTarget.getAttribute("data-gwp-type");

    // currentTarget.setAttribute('disabled', true);
    currentTarget.classList.add("loading");
    // currentTarget.querySelector('[data-btn-txt]').classList.add('d-none');
    var allBtns = currentTarget
      .closest(".modal")
      .querySelectorAll("[add-gwp-product]");
    allBtns.forEach((button) => button.classList.add("disable-element"));

    if (gwpType == "tier1") {
      var body = {
        id: parseInt(upsellProductVariantId),
        quantity: 1,
        properties: {
          product_type: "tier1",
          free_product: "true",
        },
      };
    }

    const result = fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    }).then((response) => {
      allBtns.forEach((button) => button.classList.remove("disable-element"));
      // currentTarget.setAttribute('disabled', false);
      currentTarget.classList.remove("loading");
      // currentTarget.querySelector('[data-btn-txt]').classList.remove('d-none');
      closeBtn.click();
      document.querySelector("ajax-cart").getCartData();
    });
  }

  removeSampleProducts(ids) {
    var varArray = ids.split(",");
    var data = {};

    for (let index = 0; index < varArray.length; ++index) {
      data[varArray[index]] = 0;

      if (index == varArray.length - 1) {
        const result = fetch("/cart/update.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ updates: data }),
        }).then((response) => {
          document.querySelector("ajax-cart").getCartData();
        });
      }
    }
  }

  /**
   * Fetch latest cart data
   *
   * @param {string} action Open Drawer as value if need to Open Cart drawer or else let it be empty
   */
  getCartData(action, callback) {
    window.globalVariables.calledGetCartData = true;
    
    let cartRoute = `${routes.cart_fetch_url}?sections=template-cart`;
    if (window.globalVariables.template != "cart") {
      cartRoute = `${routes.cart_fetch_url}?sections=template-cart-drawer`;
    }

    if (action != 'changed_free_gift') {
      this.checkGiftWithPurchase();
    }
    
    fetch(cartRoute, { cache: 'no-store' })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        this._updateCart(response, action);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        // Cart HTML fetch done
        if (callback) {
          callback();
        }
      });
  }

  checkGiftWithPurchase() {
    //CHECK GIFT WITH PURCHASE ELIGIBLE WHEN THERE'S A CHANGE IN CART
    //if (!window.theme.giftWithPurchase.enabled) return;
    var isGiftInCart = false;
    var isEligibleGift = false;
    //GET CURRENT CART CONTENT
    fetch("/cart.json")
      .then((response) => {
        if (response.status === 200) {
          response.json().then((updatedCart) => {
            if (updatedCart.items) {
              updatedCart.items.forEach((item, index) => {
                var handle = item.handle;
                var freeGift = item.properties["free_gift"];
                if (freeGift == true) {
                  if (item.quantity > 1) {
                    //if there're more than 1 free gift, set it as 1
                    this.updateItemQty(item.key, 1, true);
                  }
                  isGiftInCart = true; //this item is free gift
                  return;
                }
                if (
                    window.theme?.giftWithPurchase?.eligibleProducts &&
                    window.theme.giftWithPurchase.eligibleProducts.indexOf("|" + handle + "|") !== -1
                  ) {
                    isEligibleGift = true;
                    return 0;
                  }
              });

              if (window.theme.giftWithPurchase.mode == 'disabled') {
                isEligibleGift = false;
              }
              
              if (!isEligibleGift && isGiftInCart) {
                // Call remove gift to cart
                if (window.theme.giftWithPurchase.giftProducts.length > 0) {
                  window.theme.giftWithPurchase.giftProducts.forEach(product => {
                    this.removeFreeProduct(product.variantId);
                  });
                }
              }

              if (isEligibleGift && window.theme.giftWithPurchase.mode == 'auto') {
                // Check each free gift and automatically add free gifts
                if (window.theme.giftWithPurchase.giftProducts.length > 0) {
                  let variantIds = window.theme.giftWithPurchase.giftProducts.map(product => product.variantId);
                  let variantIdsToAdd = [];
                  for (var i in variantIds) {
                    let giftAlreadyAdded = false;
                    for (var j in updatedCart.items) {
                      if (updatedCart.items[j].id == variantIds[i]) {
                        giftAlreadyAdded = true;
                        break;
                      }
                    }

                    if ( !giftAlreadyAdded ) {
                      variantIdsToAdd.push(variantIds[i]);
                    }
                  }

                  if (variantIdsToAdd.length > 0) {
                    this.addFreeProduct(variantIdsToAdd);
                  }
                }
              }
            }

            if (updatedCart.item_count == 0) {
              // Reset Gift was removed when cart is empty
              sessionStorage.removeItem("gwpRemoved");
              document.querySelectorAll("ajax-cart").forEach((ajaxCart) => {
                ajaxCart.classList.add("empty-cart");
              });
            } else {
              document.querySelectorAll("ajax-cart").forEach((ajaxCart) => {
                ajaxCart.classList.remove("empty-cart");
              });
            }
          });
        } else {
          throw new Error(
            `refreshCart function failed to get request, Shopify returned ${response.status} ${response.statusText}`
          );
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        // Cart HTML fetch done
      });
  }

  addFreeProduct(productVariantId, callback) {
    //ADD FREE PRODUCT TO CART WITH VARIANT ID
    if (
      sessionStorage.getItem("gwpRemoved") ||
      getFromSessionStorage(gwpLocalCheck)
    ) {
      return;
    }
    // else add the thing
    setInSessionStorage(gwpLocalCheck, "true");

    let addData = {};

    if (typeof productVariantId == 'object') {
      addData.items = [];

      for (var i in productVariantId) {
        addData.items.push({
          id: productVariantId[i],
          quantity: 1,
          properties: {
            free_gift: true,
          }
        });
      }
         
    } else {
      addData = {
        id: productVariantId,
        quantity: 1,
        properties: {
          free_gift: true,
        },
      };
    }

    fetch("/cart/add.js", {
      body: JSON.stringify(addData),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      method: "POST",
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        removeFromSessionStorage(gwpLocalCheck);
        document.querySelector("ajax-cart").getCartData(callback); //CALL UPDATE CART
      })
      .catch(function (err) {
        console.error(err);
        removeFromSessionStorage(gwpLocalCheck);
      });
  }

  removeFreeProduct(productVariantId, callback) {
    //REMOVE FREE PRODUCT TO CART WITH VARIANT ID
    var VID = productVariantId;
    var removeData = {
      id: VID,
      quantity: 0,
      properties: {
        free_gift: true,
      },
    };
    fetch("/cart/change.js", {
      body: JSON.stringify(removeData),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      method: "POST",
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        removeFromSessionStorage(gwpLocalCheck);

        if (callback) {
          callback();
        } else {
          document.querySelector("ajax-cart").getCartData(); //CALL UPDATE CART
        }
      })
      .catch(function (err) {
        console.error(err);
        removeFromSessionStorage(gwpLocalCheck);
      });
  }

  /**
   * Update Quantity API call
   *
   * @param {string} line Line Index value of cart Item (Starts from 1)
   * @param {integer} quantity Quantity to update
   * @param {boolean} Whether free gift or not
   */
  updateItemQty(line, quantity, is_free_gift) {
    let lineItem = document.querySelector(`[data-cart-item="${line}"]`);
    if (lineItem) {
      lineItem.classList.add("updating");
    }
    var body = {};
    body[line] = quantity;
    body = JSON.stringify({ updates: body });

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        this.getCartData(is_free_gift ? "changed_free_gift" : false);
        setTimeout(() => {
          if (lineItem) {
            lineItem.classList.remove("updating");
          }
        }, 1000);
      })
      .catch((error) => {
        setTimeout(() => {
          if (lineItem) {
            lineItem.classList.remove("updating");
          }
        }, 1000);
        console.log(error);
      });
  }

  /**
   * Remove Item Event
   *
   * @param {event} Event instance
   */
  removeItem(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let itemIndex = currentTarget.dataset.index || null;
    if (currentTarget.classList.contains("free-gift-with-purchase")) {
      window.sessionStorage.setItem("gwpRemoved", "true");
    }
    if (itemIndex != null) {
      this.updateItemQty(itemIndex, 0);
      
      const lineItem = currentTarget.closest('.cart-items');
      if (lineItem) {
        const pdpUpsellContainer = document.querySelector('.section-upgrade-bundle .cart-upsell');
        if (pdpUpsellContainer) {
          if (lineItem.dataset.productId == pdpUpsellContainer.dataset.upsellProductId) {
            // Show this PDP Upsell section because you just removed this bundle product from the cart
            pdpUpsellContainer.closest('.section-upgrade-bundle').classList.remove('hidden');
            pdpUpsellContainer.querySelector('.addtocartbtn .add-text').innerText = pdpUpsellContainer.dataset.ctaLabelAdd;
          } else {
            const productForm = document.querySelector('.product-details-wrapper .product-form form');
            if (productForm && lineItem.dataset.productId == productForm.dataset.productId) {
              // You have removed the main product of this PDP
              pdpUpsellContainer.querySelector('.addtocartbtn .add-text').innerText = pdpUpsellContainer.dataset.ctaLabelAdd;
            }
          }
        }
      }
    }
  }

  /**
   * Cart Item Qunatity Increment/Decrement Button event
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || "increase";
    let $qtyInput = currentTarget
      .closest("[data-qty-container]")
      .querySelector("[data-qty-input]");
    let itemIndex = $qtyInput.dataset.index || 1;
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;

    if (action == "decrease" && currentQty <= 1) {
      return false;
    } else if (action == "decrease") {
      finalQty = currentQty - 1;
    } else {
      finalQty = currentQty + 1;
    }
    this.updateItemQty(itemIndex, finalQty);
  }

  /**
   * Cart Item Qunatity Input change event
   *
   * @param {event} Event instance
   */
  onQtyChange(event) {
    const $qtyInput = event.currentTarget;
    const qtyValue = $qtyInput.value;
    const itemIndex = $qtyInput.dataset.index || null;
    if (itemIndex) this.updateItemQty(itemIndex, qtyValue);
  }

  /**
   * Manage Cart Notes
   */
  cartNoteInput() {
    const cartNoteEle = document.querySelector('[data-cartNote] [name="note"]');
    if (!cartNoteEle) return;

    const cartNoteSave = document.querySelector("[data-saveNote]");
    let cartNoteEvents = ["input", "paste"];
    cartNoteEvents.forEach((eventName) => {
      cartNoteEle.addEventListener(
        eventName,
        () => {
          const defaultNote = cartNoteEle.dataset.default;
          if (defaultNote != cartNoteEle.value) {
            cartNoteSave.style.display = "block";
          } else {
            cartNoteSave.style.display = "none";
          }
        },
        false
      );
    });

    //  Cart Note Change event
    cartNoteSave.addEventListener("click", (e) => {
      e.preventDefault();
      const currentTarget = e.currentTarget;
      const cartNoteContainer = currentTarget.closest("[data-cartNote]");
      const cartNote = cartNoteContainer
        .querySelector('[name="note"]')
        .value.trim();
      if (cartNote.length <= 0) {
        alert("Add Note before proceeding");
        return;
      }
      const submitBtn = cartNoteContainer.querySelector("[data-saveNote]");
      const waitText = submitBtn.dataset.adding_txt
        ? submitBtn.dataset.adding_txt
        : "Saving...";
      submitBtn.innerHTML = waitText;
      submitBtn.disabled = true;
      this.updateCartNote(cartNoteContainer);
    });
  }

  /**
   * Update Cart Note
   * @param {element} cartNoteContainer
   */
  updateCartNote(cartNoteContainer) {
    const _this = this;
    const cartNoteEle = cartNoteContainer.querySelector('[name="note"]');
    const cartNote = cartNoteEle.value.trim();
    const resultEle = cartNoteContainer.querySelector("[data-resultMsg]");
    const submitBtn = cartNoteContainer.querySelector("[data-saveNote]");
    const defaultText = submitBtn.dataset.default
      ? submitBtn.dataset.default
      : "Save";

    let body = JSON.stringify({
      note: cartNote,
    });
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then(function (data) {
        if (data.status == 200) {
          if (resultEle) {
            resultEle.innerText = "Added note to Order!";
            _this.manageResponseText(resultEle);
          }
          if (cartNoteEle) {
            cartNoteEle.dataset.default = cartNote;
          }
          submitBtn.style.display = "none";
          submitBtn.innerHTML = defaultText;
          submitBtn.disabled = false;
        } else {
          console.error("Request returned an error", data);
          if (resultEle) {
            resultEle.innerText = data;
            _this.manageResponseText(resultEle);
          }
          submitBtn.innerHTML = defaultText;
          submitBtn.disabled = false;
        }
      })
      .catch(function (error) {
        console.error("Request failed", error);
        if (resultEle) {
          resultEle.innerText = error;
          _this.manageResponseText(resultEle);
        }
        submitBtn.innerHTML = defaultText;
        submitBtn.disabled = false;
      });
  }

  /**
   * fade effect on reponse
   * @param {element} element
   */
  manageResponseText(element) {
    Utility.fadeEffect(element, "fadeIn");
    setTimeout(() => {
      Utility.fadeEffect(element, "fadeOut");
    }, 3000);
  }
}
customElements.define("ajax-cart", AjaxCart);

const gwpLocalCheck = "gwpAttemptAdd";
function getFromSessionStorage(key) {
  try {
    return sessionStorage.getItem(key);
  } catch (err) {
    console.error("Could not get item from storage with key", key, err);
  }
}

function setInSessionStorage(key, value) {
  try {
    sessionStorage.setItem(key.toString(), value.toString());
  } catch (err) {
    console.error(
      "Could not set item in storage with key, value",
      key,
      value,
      err
    );
  }
}

function removeFromSessionStorage(key) {
  try {
    sessionStorage.removeItem(key);
  } catch (err) {
    console.error("Could not remove item from storage with key", key, err);
  }
}

// Subscription Feature

document.addEventListener("DOMContentLoaded", initAll);
window.addEventListener("refreshAjaxCart", initAll);

function initAll() {
  document.querySelectorAll(".cart-item").forEach((item) => {
    const variantId = item.dataset.itemId;

    const sellingPlanCheckbox = item.querySelector(`.upsell__checkbox`);
    const sellingPlanOptions = item.querySelector(`.upsell__options`);

    if (
      sellingPlanCheckbox &&
      sellingPlanOptions &&
      !item.dataset.listenerAdded
    ) {
      sellingPlanCheckbox.addEventListener(
        "change",
        handleCheckboxChange.bind(null, sellingPlanCheckbox, sellingPlanOptions)
      );
      sellingPlanOptions.addEventListener(
        "change",
        handleOptionsChange.bind(null, sellingPlanCheckbox, sellingPlanOptions)
      );

      item.dataset.listenerAdded = true;
    }
  });
}

async function handleCheckboxChange(sellingPlanCheckbox, sellingPlanOptions) {
  const variantId = sellingPlanCheckbox.dataset.variantId;
  showOverlay();
  if (sellingPlanCheckbox.checked) {
    sellingPlanOptions.style.display = "block";
    await addOrUpdateSellingPlan(
      variantId,
      sellingPlanOptions.options[0].value
    );
  } else {
    sellingPlanOptions.style.display = "none";
    await removeSellingPlan(variantId, sellingPlanOptions.value);
  }

  // Refresh cart code
  document.querySelector("ajax-cart").getCartData();

  setTimeout(() => {
    hideOverlay();
  }, 1000);
}

async function handleOptionsChange(sellingPlanCheckbox, sellingPlanOptions) {
  const variantId = sellingPlanCheckbox.dataset.variantId;
  if (sellingPlanCheckbox.checked) {
    showOverlay();
    await addOrUpdateSellingPlan(variantId, sellingPlanOptions.value);

    // refresh Cart Code
    document.querySelector("ajax-cart").getCartData();

    setTimeout(() => {
      hideOverlay();
    }, 1000);
  }
}

async function addOrUpdateSellingPlan(variant, plan) {
  const cart = await getCart();
  const lineItemWithPlan = findLineItemWithPlan(cart, variant);
  const lineItemWithoutPlan = findLineItemWithoutPlan(cart, variant);
  let quantity;

  if (lineItemWithoutPlan) {
    quantity = lineItemWithoutPlan.quantity;
  } else if (lineItemWithPlan) {
    quantity = lineItemWithPlan.quantity;
  } else {
    quantity = 1;
  }

  const result = await addLineItemPlan(variant, plan, quantity);
  if (lineItemWithPlan) await removeLineItem(lineItemWithPlan.key);
  if (lineItemWithoutPlan) await removeLineItem(lineItemWithoutPlan.key);

  return result;
}

async function removeSellingPlan(variant, plan) {
  const cart = await getCart();
  const lineItemWithPlan = findLineItemWithPlan(cart, variant);

  if (lineItemWithPlan) {
    await removeLineItem(lineItemWithPlan.key);
    await addLineItem(variant, lineItemWithPlan.quantity);
  }
}

async function getCart() {
  const result = await fetch("/cart.json");
  if (result.status === 200) return result.json();
  throw new Error(
    `Failed to get request, Shopify returned ${result.status} ${result.statusText}`
  );
}

function findLineItemWithPlan(cart, variant) {
  return cart.items.find(
    (item) => item.id === parseInt(variant) && item.selling_plan_allocation
  );
}

function findLineItemWithoutPlan(cart, variant) {
  return cart.items.find(
    (item) => item.id === parseInt(variant) && !item.selling_plan_allocation
  );
}

function removeLineItem(key) {
  return postToShopify("cart/change.js", {
    id: key,
    quantity: 0,
  });
}

function addLineItemPlan(variant, plan, quantity) {
  return postToShopify("cart/add.js", {
    items: [
      {
        quantity: quantity,
        id: variant,
        selling_plan: plan,
      },
    ],
  });
}

function addLineItem(variant, quantity) {
  return postToShopify("cart/add.js", {
    items: [
      {
        quantity: quantity,
        id: variant,
      },
    ],
  });
}

function postToShopify(endpoint, formData) {
  return fetch(window.Shopify.routes.root + endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (!response.ok) throw new Error(response.statusText);
      return response.json();
    })
    .then((data) => {
      console.log("Response:", data);
      return data;
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function showOverlay() {
  document.getElementById("cart-overlay").style.display = "flex";
}

function hideOverlay() {
  document.getElementById("cart-overlay").style.display = "none";
}
